<template>
  <div class="rule">
    <div class="rule__bold">活动时间：即日起～2023.8.30</div>
    <div class="rule__bold">活动期内免费选配内容：</div>
    <div class="rule__normal">· YAMAHA环绕立体式高级音响</div>
    <div class="rule__normal">· 智能按摩座椅舒适套装</div>
    <div class="rule__normal">· 副驾驶座椅通风</div>
    <div class="rule__normal">· 智能感应自动门套装</div>
    <div class="rule__normal">· 限定随机配置</div>
    <div class="rule__normal">&nbsp;</div>
    <div class="rule__normal">以上内容任选其一，您可选择一项最感兴趣的选装包进行体验，我们将根据您的选择为您调配车辆；<br>“限定随机配置”是指以上选配内容随机组合分配，或可能分配到无选装包配置的车辆，具体配置情况请以实际交付为准。</div>
  </div>
</template>
<style scoped>
.rule {
  font-family: 'PingFang SC';
  height: 100%;
  overflow: auto;
  color: rgba(124, 127, 128, 1);
  font-size: 14px;
  font-size: 3.7333333333333336vw;
  padding: 16px 20px;
  padding: 4.2666666666666665vw 5.333333333333334vw;
}
.rule__bold {
  color: rgba(81, 84, 85, 1);
  font-weight: bold;
}
.rule__normal {
  margin-top: 2px;
  margin-top: 0.5333333333333333vw;
}
.rule__bold + .rule__normal {
  margin-top: 8px;
  margin-top: 2.1333333333333333vw;
}
.rule__bold {
  margin-top: 16px;
  margin-top: 4.2666666666666665vw;
}
</style>